export default __webpack_public_path__ + "static/media/f_mobileapp_dev.90381947.png";